import { handleError } from 'config/libraries';
import React, { useState, useEffect } from 'react'
import Slider from 'react-slick/lib/slider';

export const Sliders = () => {
    const [DataResponseBanner, setDataResponseBanner] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToScroll: 1
    };

    useEffect(() => {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/banner').then(function (response) {
            setDataResponseBanner(response.data.data);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponseBanner(null);
        };
    }, []);

    return (
        <section className="partners-section-two rel bg-gray pb-60 rpb-30">
            <div className="container">
                <div className="partner-dashboard mb-75">
                    <div className="dashboard-screenshot-wrap slick-initialized slick-slider">
                        <Slider {...settings}>
                            {
                                DataResponseBanner && DataResponseBanner.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <img className="portal-corousel-size" src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_banner} alt={item.judul_banner}/>
                                        </div>
                                    )
                                })
                            }
                        </Slider>
                    </div>
                </div>
            </div>
            <div className="bg-yellow-shape" />
        </section>
    )
};